import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";
import { HttpClientModule } from "@angular/common/http";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { FlexLayoutModule } from "@angular/flex-layout";

import { AppRoutingModule } from "./app-routing.module";

import { AppComponent } from "./app.component";
import { MaterialModule } from "./material.module";
import { HomePageComponent } from "./home-page/home-page.component";
// import { ToolbarComponent } from './shared/components/toolbar/toolbar.component';
import { LandingPageComponent } from "./shared/components/landing-page/landing-page.component";
import { CoreModule } from "./core/core.module";
import { SharedModule } from "./shared/sharedModule/shared/shared.module";
import { TransferConfirmationComponent } from "./shared/modals/transfer-confirmation/transfer-confirmation.component";
import { UploadTransferListComponent } from "./shared/modals/upload-transfer-list/upload-transfer-list.component";
import { GenerateLinkComponent } from "./shared/modals/generate-link/generate-link.component";
import { LinkComponent } from "./shared/modals/link/link.component";
import { HTTP_INTERCEPTORS } from "@angular/common/http";
import { CustomHttpInterptors } from "./core/interceptors/customHttpInterceptors";
import { ToastrModule } from "ng6-toastr-notifications";
import { Notification } from "./core/helpers/notification";
import { ErrorHandlers } from "./core/helpers/errorhandlers";
import { DisbursementReponseComponent } from "./shared/modals/disbursement-reponse/disbursement-reponse.component";
import { VerificationResponseComponent } from "./shared/modals/verification-response/verification-response.component";
import { CustomerDetailsComponent } from "./shared/modals/customer-details/customer-details.component";
import { SysSettingsComponent } from "./shared/components/settings/sys-settings/sys-settings.component";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { ApproveRequestComponent } from "./shared/modals/approve-request/approve-request.component";
import { DashaboardComponent } from "./pages/dashboard/dashaboard/dashaboard.component";
import { ChartsModule } from "ng2-charts";
import { DatePickerModule } from "@syncfusion/ej2-angular-calendars";
import { SettlementComponent } from "./pages/transactions/settlement/settlement.component";
import {
  EligibleProfileGuard,
  LoginGuardForProfile,
} from "./core/guards/eligible-profile.guard";
import { TransactionsService } from "./pages/transactions/services/transactions.service";
import { PaymentGuard } from "./core/guards/payment/payment.guard";
import { UsersGuard } from "./core/guards/users/users.guard";
import { TransactionGuard } from "./core/guards/transactions/transaction.guard";
import { SettlementGuard } from "./core/guards/settlement/settlement.guard";
import { BusinessGuard } from "./core/guards/Business/business.guard";
import { DashboardHomeComponent } from "./pages/dashboard/dashboard-home/dashboard-home.component";
import { DashboardGHComponent } from "./pages/dashboard/dashboard-gh/dashboard-gh.component";
import { PaymentService } from "./pages/receive/services/payment.service";
import { DesignPageComponent } from "./pages/design-page/design-page.component";
import { PrivacyPolicyComponent } from "./pages/privacy-policy/privacy-policy.component";
import { ApiKeySetupComponent } from "./pages/api-key-setup/api-key-setup.component";
import { DataServiceService } from "./pages/home/data-service.service";

@NgModule({
  declarations: [
    AppComponent,
    HomePageComponent,
    LandingPageComponent,
    TransferConfirmationComponent,
    UploadTransferListComponent,
    GenerateLinkComponent,
    LinkComponent,
    DisbursementReponseComponent,
    VerificationResponseComponent,
    CustomerDetailsComponent,
    SysSettingsComponent,
    ApproveRequestComponent,
    DashaboardComponent,
    SettlementComponent,
    DashboardHomeComponent,
    DashboardGHComponent,
    DashaboardComponent,
    DesignPageComponent,
    PrivacyPolicyComponent,
    ApiKeySetupComponent,
  ],
  imports: [
    BrowserAnimationsModule,
    BrowserModule,
    HttpClientModule,
    AppRoutingModule,
    MaterialModule,
    FlexLayoutModule,
    CoreModule,
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
    ToastrModule.forRoot(),
    ChartsModule,
    DatePickerModule,
  ],
  entryComponents: [
    TransferConfirmationComponent,
    UploadTransferListComponent,
    GenerateLinkComponent,
    LinkComponent,
    DisbursementReponseComponent,
    VerificationResponseComponent,
    CustomerDetailsComponent,
    ApproveRequestComponent,
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: CustomHttpInterptors, multi: true },
    {
      provide: "nonce",
      useValue: "f4e0cf5418c8baaf1d0b977280e73bdc",
    },
    Notification,
    ErrorHandlers,
    EligibleProfileGuard,
    LoginGuardForProfile,
    PaymentGuard,
    UsersGuard,
    TransactionGuard,
    SettlementGuard,
    TransactionsService,
    PaymentService,
    BusinessGuard,
    DataServiceService,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
